const detectMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
export const isMobile = detectMobile();

export const hexToRgb = (hex) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    }
    : null;
}

export const isPointInCircle = ({ circle, e, canvasRect }) => {
  let pageX;
  let pageY;

  if (e.pageX && e.pageY) {
    pageX = e.pageX;
    pageY = e.pageY;
  } else if (e.touches[0]) {
    pageX = e.touches[0].clientX;
    pageY = e.touches[0].clientY;
  } else if (e.changedTouches[0]) {
    pageX = e.changedTouches[0].clientX;
    pageY = e.changedTouches[0].clientY;
  }

  const X = pageX - canvasRect.left;
  const Y = pageY - canvasRect.top;
  const dX = X - circle.x;
  const dY = Y - circle.y;
  const dist = Math.sqrt(dX * dX + dY * dY);

  return dist < circle.radius;
}


// WEBPACK FOOTER //
// ./src/components/util/index.jsx